import {defineStore} from 'pinia'
import {config} from "@/core/config";

interface ProductVariantInterface {
  link: string
  availability: string
  title: string
  price: number
  image_link: string
  suggestions: Array<string>
  status: string
  
  [key: string]: string | number | Array<string> | boolean;
}


interface ProductInterface {
  id: string
  link: string
  link_click: string
  price: number
  title: string
  variants: Array<ProductVariantInterface>
  
}

export const useSliderStore = defineStore('sliderStore', {
  state: () => {
    return {
      sliderIsLoading: true,
      products: [] as ProductInterface[],
    }
  },
  getters: {
    getSliderLoading(state) {
      return state.sliderIsLoading
    },
    getProducts(state) {
      return state.products
    },
    hasProducts(state) {
      return state.products.length > 0
    }
  },
  actions: {
    setSliderLoading(value: boolean) {
      this.sliderIsLoading = value
    },
    setProducts(product: ProductInterface[]) {
      this.products = product
    },
    shuffle(array: ProductInterface[]) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },
    getRandomNumber() {
      return Math.floor(Math.random() * 11);
    },
    async fetchProducts() {
      const {customerSymbol, apiHost, searchId, apiKey} = config
      const page = `?p=${this.getRandomNumber()}`
      try {
        const response = await fetch(
          `https://${apiHost}/restapi/${customerSymbol}/search/${searchId}/products${page}`,
          {
            method: 'GET',
            headers: {
              'Api-key': apiKey,
            },
            credentials: 'include',
          }
        )
        
        if (response.ok) {
          const {products} = await response.json()
          this.shuffle(products)
          this.setSliderLoading(false)
          this.setProducts(products)
        }
      } catch (error) {
        this.setSliderLoading(false)
      }
    },
    
    
  }
})